import { http } from "./http";
// import moment from "moment";

// 학교 조회
// export async function selectSchool(name) {
//   try {
//     const res = await http.get(`/school/${name}`);
//     if (res.data.code === 1) {
//       return res.data.school_list;
//     } else {
//       return [];
//     }
//   } catch (error) {
//     console.error("학교 조회: ", error);
//     throw error;
//   }
// }

// 제품 타입 조회
// export async function selectDeviceType(idx) {
//   try {
//     const res = await http.get(`/as/device/type/${idx}`);
//     if (res.data.code === 1) {
//       return res.data.as_list;
//     } else {
//       return [];
//     }
//   } catch (error) {
//     console.error("제품 타입 조회: ", error);
//     throw error;
//   }
// }

// 접수 유형 조회
// export async function selectRequestType(idx) {
//   try {
//     const res = await http.get(`/as/request/type/${idx}`);
//     if (res.data.code === 1) {
//       return res.data.as_list;
//     } else {
//       return [];
//     }
//   } catch (error) {
//     console.error("접수 유형 조회: ", error);
//     throw error;
//   }
// }

// 진행 여부 조회
// export async function selectIsProcessed(idx) {
//   try {
//     const res = await http.get(`/as/isprocessed/${idx}`);
//     if (res.data.code === 1) {
//       return res.data.as_list;
//     } else {
//       return [];
//     }
//   } catch (error) {
//     console.error("진행 여부 조회: ", error);
//     throw error;
//   }
// }

// 처리 유형 조회
// export async function selectProcessType(idx) {
//   try {
//     const res = await http.get(`/as/process/type/${idx}`);
//     if (res.data.code === 1) {
//       return res.data.as_list;
//     } else {
//       return [];
//     }
//   } catch (error) {
//     console.error("처리 유형 조회: ", error);
//     throw error;
//   }
// }

// 처리 현황 조회
// export async function selectProcessDevice(idx) {
//   try {
//     const res = await http.get(`/as/process/device/${idx}`);
//     if (res.data.code === 1) {
//       return res.data.as_list;
//     } else {
//       return [];
//     }
//   } catch (error) {
//     console.error("처리 현황 조회: ", error);
//     throw error;
//   }
// }

/**
 * AS 접수내역 등록
 */
// export async function insertASRequest(asRequest) {
//   try {
//     const body = {
//       receipt_date: moment(asRequest.receivedDate).format(
//         "YYYY-MM-DD HH:mm:ss"
//       ),
//       school_id: asRequest.schoolId,
//       customer_name: asRequest.customerName,
//       customer_phone: asRequest.customerPhone,
//       device_type_id: asRequest.deviceType,
//       manufacturer: asRequest.manufacturer,
//       location_detail: asRequest.classroomLocation,
//       issue_description: asRequest.issue,
//       delivery_date: asRequest.installationDate,
//       is_transfer: asRequest.transferStatus,
//       request_type: asRequest.receiptType,
//       request_date: moment(asRequest.requestVisitDate).format(
//         "YYYY-MM-DD HH:mm:ss"
//       ),
//       u_name: asRequest.receiver
//     };
//     const res = await http.post(`/as/request`, body);
//     if (res.data.code === 1) {
//       return true;
//     } else {
//       return false;
//     }
//   } catch (error) {
//     console.error("AS 접수내역 등록: ", error);
//     throw error;
//   }
// }

// as 접수내역 조회
export async function selectASRequest(data) {
  try {
    const body = {
      school_name: data.school_name,
      customer_name: data.u_name,
      start_date: data.receipt_date_from,
      end_date: data.receipt_date_to
    };
    const res = await http.post(`/as/request/sheet`, body);
    if (res.data.code === 1) {
      return res.data;
    } else {
      return {
        tech_as_list: [],
        blend_as_list: []
      };
    }
  } catch (error) {
    console.error("as 접수내역 조회: ", error);
    throw error;
  }
}

// as 접수내역 수정
// export async function updateASRequest(payload) {
//   try {
//     const body = {
//       device_uuid: device.uuid,
//       name: device.name,
//       group_id: device.group_id,
//       status: device.status
//     };
//     const res = await http.put(`/device`, body);
//     if (res.data.code === 1) {
//       return true;
//     } else {
//       return false;
//     }
//   } catch (error) {
//     console.error("디바이스 생성: ", error);
//     throw error;
//   }
// }

// // 디바이스 삭제
// export async function removeDevice(uuid) {
//   try {
//     const res = await http.delete(`/device/${uuid}`);
//     if (res.data.code === 1) {
//       return true;
//     } else {
//       return false;
//     }
//   } catch (error) {
//     console.error("그룹 삭제: ", error);
//     throw error;
//   }
// }
